import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { format } from 'date-fns';
import moment from 'moment';
import { CommonListQuery, } from '../../../../redux/api/apiTypes';
import { ReportParams, CheckedItem } from './apiTypes';

export const checkedReportApi = createApi({
    reducerPath: 'checkedReportApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/api/v1/reports",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getCheckedReport: builder.query<CheckedItem[], { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/report-checked/search`,
                method: 'POST',
                params: {
                    pageNumber: body.page || 0,
                    pageSize: body.size || 10,
                    sortType: 0,
                },
                body: {
                    checkedBys: body?.searchParam?.checkedBys,
                    typeBooks: body?.searchParam?.typeBooks,
                    provinceIds: body?.searchParam?.provinceIds,
                    districtIds: body?.searchParam?.districtIds,
                    communeIds: body?.searchParam?.communeIds,
                    fromDateStr: body?.searchParam?.dates && body.searchParam.dates[0] ? moment(body.searchParam.dates[0]).format("YYYY-MM-DD") : undefined,
                    toDateStr: body?.searchParam?.dates && body.searchParam.dates[1] ? moment(body.searchParam.dates[1]).format("YYYY-MM-DD") : undefined
                }
            }),
            transformResponse: (response: { data: CheckedItem[] }, meta, arg) => {
                return response.data;
            },
        }),
        getCheckedReportTotal: builder.query<number, { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/report-checked/count`,
                method: 'POST',
                body: {
                    checkedBys: body?.searchParam?.checkedBys,
                    typeBooks: body?.searchParam?.typeBooks,
                    provinceIds: body?.searchParam?.provinceIds,
                    districtIds: body?.searchParam?.districtIds,
                    communeIds: body?.searchParam?.communeIds,
                    fromDateStr: body?.searchParam?.dates && body.searchParam.dates[0] ? moment(body.searchParam.dates[0]).format("YYYY-MM-DD") : undefined,
                    toDateStr: body?.searchParam?.dates && body.searchParam.dates[1] ? moment(body.searchParam.dates[1]).format("YYYY-MM-DD") : undefined
                }
            }),
            transformResponse: (response: { data: number }, meta, arg) => {
                return response.data;
            },
        }),
        exportData: builder.mutation<any, { searchParam?: ReportParams } & Partial<CommonListQuery>>({
            query: (body) => ({
                url: `/report-checked/export`,
                method: 'POST',
                params: {
                    sortType: 0
                },
                body: {
                    checkedBys: body?.searchParam?.checkedBys,
                    typeBooks: body?.searchParam?.typeBooks,
                    provinceIds: body?.searchParam?.provinceIds,
                    districtIds: body?.searchParam?.districtIds,
                    communeIds: body?.searchParam?.communeIds,
                    fromDateStr: body?.searchParam?.dates && body.searchParam.dates[0] ? moment(body.searchParam.dates[0]).format("YYYY-MM-DD") : undefined,
                    toDateStr: body?.searchParam?.dates && body.searchParam.dates[1] ? moment(body.searchParam.dates[1]).format("YYYY-MM-DD") : undefined
                },
                responseHandler: async (response) => {
                    let filename = `${format(new Date(), "dd-MM-yyyy")}_Báo cáo kiểm tra.xlsx`;
                    let blob = await response.blob();
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename);
                    link.click();
                },
                cache: "no-cache",
            }),
        }),
    })
})

export const {
    useLazyGetCheckedReportQuery,
    useLazyGetCheckedReportTotalQuery,
    useExportDataMutation,
} = checkedReportApi;

export default checkedReportApi;